// extracted by mini-css-extract-plugin
export default {"comments":"PostId_comments__dAwnX","wrapper":"PostId_wrapper__iUshs","comment":"PostId_comment__lAD8d","title":"PostId_title__kk24h"};